import { CONFIG } from 'config/config';

import { isMobile } from 'react-device-detect';
import styled from 'styled-components/macro';

export const InnerWrapper = styled.div`
	flex-grow: 1;
	width: 100%;
`;

export const DocumentWrapper = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	padding: 16px 10px;
	width: 100%;
	border-radius: 10px;
`;
export const DocumentWrapperText = styled.p`
	font-size: ${CONFIG.fontSizes.md};
	color: ${CONFIG.colors.black};
	font-family: ${CONFIG.fonts.semiBold};
	overflow-x: hidden;
	margin-right: 20px;
`;

export const DocumentWrapperButtons = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 10px;
	justify-items: flex-end;
	align-items: center;
`;
export const DocumentWrapperIconPDF = styled.img`
	width: 16px;
	height: auto;
	cursor: pointer;
	color: ${(props) => {
		if (props.selected) {
			return CONFIG.colors.secondary;
		} else {
			return CONFIG.colors.primary;
		}
	}};
`;
export const DocumentWrapperIconDownload = styled.img`
	width: 14px;
	height: auto;
	cursor: pointer;
`;
export const DocumentButton = styled.button`
	text-align: center;
	cursor: pointer;
	outline: none;

	transition: all 0.3s;

	color: ${(props) => {
		if (props.selected) {
			return CONFIG.colors.primaryLighter;
		} else {
			return CONFIG.colors.primary;
		}
	}};
	background-color: ${(props) => {
		if (props.selected) {
			return CONFIG.colors.primary;
		} else {
			return 'white';
		}
	}};
	font-size: 16px;
	padding: 10px 15px;
	border-radius: 10px;
	border: 1px solid ${CONFIG.colors.primary};
	margin: 0px 8px;
	margin-top: 15px;
	:focus {
		outline: none;
	}
`;

export const DocumentLabel = styled.div`
	text-align: center;
	user-select: none;
	outline: none;

	transition: all 0.3s;

	color: ${(props) => {
		if (props.read) {
			return CONFIG.colors.primaryLighter;
		} else {
			return CONFIG.colors.primaryDark;
		}
	}};
	background-color: ${(props) => {
		if (props.read) {
			return CONFIG.colors.primaryDark;
		} else {
			return CONFIG.colors.white;
		}
	}};
	font-size: 12px;
	padding: 3px;
	border-radius: 3px;
	border: 1px solid ${CONFIG.colors.primaryDark};
`;
export const StepWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	margin-top: 16px;
`;
export const StepWrapperItem = styled.div`
	display: flex;
	align-items: center;
	margin-top: 20px;
	justify-content: flex-start;
	margin-bottom: ${isMobile ? '15px' : '40px'};
`;
export const StepCircle = styled.div`
	height: 36px;
	width: 36px;
	background-color: ${CONFIG.colors.primary};
	border-radius: 50%;
	margin-right: 15px;
	font-size: ${isMobile ? '16px' : '17px'};
	color: white;
	display: flex;
	justify-content: center;
	align-items: center;
	font-weight: 700;
`;
